import { Spacer as SpacerComponent } from 'components/Spacer';
import type { Spacer as TSpacer } from 'server/repository/hygraph/generated/graphqlTypes';
import type { ISharedTemplateProps } from 'templates/TemplateMapper/types';

interface ISpacer extends ISharedTemplateProps {
  templateProps?: TSpacer;
  background?: string;
}

export const Spacer = ({ templateProps, background }: ISpacer) => (
  <SpacerComponent {...templateProps} background={background} />
);
